import { useCallback, useEffect, useState } from 'react';
import {Breadcrumb, BreadcrumbButton, BreadcrumbDivider, BreadcrumbItem, makeStyles, tokens } from '@fluentui/react-components';
import * as SDK from 'azure-devops-extension-sdk';
import { AuthorizationSteps } from 'src/components/shared/authorization-steps';
import { createAuthClient } from 'src/http-client';
import AuhtorizationSkeleton from 'src/components/shared/authorization-steps/skeleton';

function getErrorObject(error: unknown): Error {
	if (error instanceof Error) return error;
	return new Error('Error message not specified');
}

export default function AdminPage() {
	const classes = useStyles();

	const [context, setContext] = useState<{ organizationName: string; organizationId: string } | null>(null);
	const [pageIsReady, setPageIsReady] = useState<boolean>(false);
	const [, setError] = useState<Error | null>(null);

	const init = useCallback(async () => {
		try {
			SDK.init({ loaded: false, applyTheme: true });
			await SDK.ready();
			SDK.notifyLoadSucceeded();

			const [host, accessToken] = await Promise.all([
				SDK.getHost(),
				SDK.getAccessToken(),
			]);

			setContext({
				organizationName: host.name,
				organizationId: host.id,
			});

			createAuthClient({ token: accessToken });

		} catch (error) {
			const errorObject = getErrorObject(error);
			setError(errorObject);
		}
	}, []);

	useEffect(() => {
		const asyncInit = async () => {
			try {
				await init();
			}
			finally {
				setPageIsReady(true);
			}
		};

		asyncInit();
	}, []);

	if (!pageIsReady) {
		return (
			<div className={classes.root}>
				<AuhtorizationSkeleton />
			</div>
		);
	}

	return (
		<div className={classes.root}>
			<div className={classes.breadcrumb}>
				<Breadcrumb aria-label="Breadcrumb default example">
					<BreadcrumbItem>
						Appgami Automation
					</BreadcrumbItem>
					<BreadcrumbDivider />
					<BreadcrumbItem>
						<BreadcrumbButton disabled current>Finish setup</BreadcrumbButton>
					</BreadcrumbItem>
				</Breadcrumb>
			</div>
			<AuthorizationSteps
				organizationName={context!.organizationName}
				organizationId={context!.organizationId}
			/>
		</div>
	);
}

const useStyles = makeStyles({
	root: {
		padding: '16px',
		flex: 1,
	},
	breadcrumb: {
		padding: '8px 16px',
	},
	title: {
		display: 'inline-block',
		borderRadius: '4px',
		boxSizing: 'border-box',
		width: '100%',
		fontFamily: tokens.fontFamilyBase,
		fontSize: tokens.fontSizeBase500,
		fontWeight: tokens.fontWeightSemibold,
		lineHeight: tokens.lineHeightBase500,
		color: tokens.colorNeutralForeground1,
		marginBottom: '8px',
	},
	description: {
		fontFamily: tokens.fontFamilyBase,
		fontSize: tokens.fontSizeBase300,
		fontWeight: tokens.fontWeightRegular,
		lineHeight: tokens.lineHeightBase300,
		color: tokens.colorNeutralForeground1,
		marginBottom: '16px',
	},
	skeletonRoot: {
		padding: '0px',
	},
	skeletonItem: {
		height: '32px',
		backgroundColor: tokens.colorNeutralBackground5,
		':after': {
			backgroundImage: `linear-gradient(to right, ${tokens.colorNeutralBackground5} 0%, ${tokens.colorNeutralBackground2} 50%, ${tokens.colorNeutralBackground5} 100%)`
		}
	}
});